import axios from '@/libs/api.request';

//通用get方法
export const getData = (url, params) => {
  return axios.request({
    url: url,
    method: 'get',
    params,
  });
};
//通用post方法
export const postData = (url, params) => {
  return axios.request({
    url: url,
    method: 'post',
    data: params,
  });
};
